import { getDefaultMargin, getDefaultTypography, getDefaultWidthOverlay } from '../utils'

export const ImageDesignSettings = {
  'image-design-width': {
    phone: ['100%'],
    'phone-landscape': ['50%'],
    tablet: ['100%'],
    'tablet-landscape': ['50%'],
    desktop: ['300px'],
    tv: ['300px'],
    overflowSetting: getDefaultWidthOverlay,
  },
  'image-design-border': {
    phone: [0],
    'phone-landscape': [0],
    tablet: [0],
    'tablet-landscape': [0],
    desktop: [0],
    tv: [0],
  },
  'image-design-shape': {
    phone: 'medium',
    'phone-landscape': 'medium',
    tablet: 'medium',
    'tablet-landscape': 'medium',
    desktop: 'medium',
    tv: 'medium',
  },
  'image-design-ratio': {
    phone: 'auto',
    'phone-landscape': 'auto',
    tablet: 'auto',
    'tablet-landscape': 'auto',
    desktop: 'auto',
    tv: 'auto',
  },

  // alignment
  'image-design-h-align': {
    phone: 'parent',
    'phone-landscape': 'parent',
    tablet: 'parent',
    'tablet-landscape': 'parent',
    desktop: 'parent',
    tv: 'parent',
  },

  'image-design-comp-title-align': {
    phone: 'center',
    'phone-landscape': 'center',
    tablet: 'center',
    'tablet-landscape': 'center',
    desktop: 'center',
    tv: 'center',
  },

  'image-design-margin': {
    phone: getDefaultMargin(),
    'phone-landscape': getDefaultMargin(),
    tablet: getDefaultMargin(),
    'tablet-landscape': getDefaultMargin(),
    desktop: getDefaultMargin(),
    tv: getDefaultMargin(),
  },

  //(nested) typography
  'image-design-typography': {
    'image-design-caption-typography': {
      phone: getDefaultTypography('Body Small'),
      'phone-landscape': getDefaultTypography('Body Small'),
      tablet: getDefaultTypography('Body Small'),
      'tablet-landscape': getDefaultTypography('Body Small'),
      desktop: getDefaultTypography('Body Small'),
      tv: getDefaultTypography('Body Small'),
    },
    'image-design-tag-typography': {
      phone: getDefaultTypography('Body Small'),
      'phone-landscape': getDefaultTypography('Body Small'),
      tablet: getDefaultTypography('Body Small'),
      'tablet-landscape': getDefaultTypography('Body Small'),
      desktop: getDefaultTypography('Body Small'),
      tv: getDefaultTypography('Body Small'),
    },
  },
}
